import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["partnerCount", "quoteCount"]

  connect() {
    fetch("https://app.documento.hu/stats").then((response) => {
      if (response.ok) {
        response.json().then((data) => {
          this.quoteCountTargets.forEach((target) =>
            target.textContent = this.#formatNumber(data.quote_count)
          )
          this.partnerCountTarget.textContent = this.#formatNumber(data.partner_count)
        })
      }
    })
  }

  #formatNumber(number) {
    return number.toLocaleString("hu-HU")
  }
}
